import { Service } from '@roc/client-portal-shared/services';

const url = {
  VALIDATE_FUNDING_DOCS_LINK: '/api/v1/closingDocs/public/validateFundingDocsLink',
  UPLOAD_FUNDING_DOCS: '/api/v1/closingDocs/public/uploadFundingDocs',
};

export class FundingDocsService extends Service {
  /** Resolves with the loan id the signed link grants access to. */
  validateFundingDocsLink(token: string) {
    return this.get(url.VALIDATE_FUNDING_DOCS_LINK, { token });
  }

  uploadFundingDocs(token: string, files: File[]) {
    const formData = new FormData();
    formData.append('token', token);
    files.forEach(file => formData.append('files', file));

    return this.post(url.UPLOAD_FUNDING_DOCS, formData);
  }
}
